import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LearnDashboard from "./LearnDashboard";
import FinanceDashboard from "./FinanceDashboard";

/**
 * Main Home component that switches between Learn and Finance dashboards
 * 
 * This component acts as a router between the two distinct dashboard experiences:
 * - LearnDashboard: Educational focus with progress tracking, streaks, and learning activities
 * - FinanceDashboard: Financial focus with budgets, savings, investments, and expense tracking
 * 
 * The mode is determined by localStorage and can be switched via the sidebar
 */
const LearnerHome = () => {
  const navigate = useNavigate();
  const [mode, setMode] = useState<'learn' | 'invest'>(() => {
    return (localStorage.getItem('navigationMode') as 'learn' | 'invest') || 'learn';
  });

  // Listen for navigation mode changes from sidebar
  useEffect(() => {
    const handleModeChange = (event: CustomEvent) => {
      const newMode = event.detail;
      console.log("Home - Navigation mode changed to:", newMode);
      setMode(newMode);
    };

    window.addEventListener('navigationModeChange', handleModeChange as EventListener);
    
    // Check initial mode from localStorage
    const currentMode = (localStorage.getItem('navigationMode') as 'learn' | 'invest') || 'learn';
    setMode(currentMode);

    return () => {
      window.removeEventListener('navigationModeChange', handleModeChange as EventListener);
    };
  }, []);

  // Render the appropriate dashboard based on current mode
  if (mode === 'invest') {
    return <FinanceDashboard />;
  }

  return <LearnDashboard />;
};

export default LearnerHome;